export async function createUserSearchView(userDb: any, logger: any) {
  logger.info('create workout selection for user view index');

  const doc = {
    _id: '_design/user-search',
    views: {
      'user-search': {
        map: `function (doc) {
          if (doc.fullname) {
            emit(doc.fullname.toLowerCase(), doc._id);
          }
          if (doc.email) {
            emit(doc.email.toLowerCase(), doc._id);
          }
          if (doc.firstname) {
            emit(doc.firstname.toLowerCase(), doc._id);
          }
          if (doc.lastname) {
            emit(doc.lastname.toLowerCase(), doc._id);
          }
          if (doc.nickname) {
            emit(doc.nickname.toLowerCase(), doc._id);
          }
          if (doc.heartRateMonitors && doc.heartRateMonitors.studio) {
            const formattedBeltId = doc.heartRateMonitors.studio.replace(/\\D/g, '').slice(-7).replace(/^0+/, '');
            emit(formattedBeltId, doc._id);
          }
        }`,
      },
    },
  };

  await userDb.put(doc);
}

export async function createUserSignedUpAfterView(userDb: any, logger: any) {
  const doc = {
    _id: '_design/user-search',
    views: {
      'signupdate-and-gym': {
        map: `function (doc) {
          if (!doc.userSignupDate || !doc.gymName) {
            return;
          }

          var dateAsIsoString = new Date(doc.userSignupDate).toISOString();
          emit([dateAsIsoString, doc.gymName], doc._id);
        }`,
      },
    },
  };

  await userDb.put(doc);
}

export async function createWorkoutImportConfigView(userDb: any, logger: any) {
  const doc = {
    _id: '_design/user-search',
    views: {
      'external-workout-import-config': {
        map: `function (doc) {
          if (Array.isArray(doc.WorkoutImportConfig)) {
            doc.WorkoutImportConfig.forEach(function (entry) {
              if (entry.origin && entry.userId) {
                emit([entry.origin, entry.userId], doc._id);
              }
            });
          }
        }`,
      },
    },
  };
  await userDb.put(doc);
}
